module.exports = __webpack_public_path__ + "img/thumb_golem.adbabf77.jpg";